import React, { useMemo } from 'react';

import { getLanguageList, getLocale, useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import { FormGroup } from '../../../common-components';
import messages from '../../messages';

const PreferredLanguageField = (props) => {
  const { formatMessage } = useIntl();
  const {
    value,
    handleChange,
    handleErrorChange,
    errorMessage,
    required = true,
    name = 'preferred_language',
  } = props;

  const OPTIONS = useMemo(() => {
    const locale = getLocale();
    const languages = getLanguageList(locale).map(({ code, name: langName }) => ({
      value: code,
      label: langName,
    }));

    return [
      {
        value: '',
        label: formatMessage(messages['registration.preferred_language.label']),
      },
      ...languages,
    ];
  }, [formatMessage]);

  const handleOnChange = (e) => {
    handleChange({ target: { name, value: e.target.value } });
    if (errorMessage) { handleErrorChange(name, ''); }
  };

  const handleOnBlur = (e) => {
    if (required && !e.target.value) {
      handleErrorChange(
        name,
        formatMessage(messages['empty.preferred_language.field.error']),
      );
    }
  };

  const handleOnFocus = () => {
    handleErrorChange(name, '');
  };

  const renderOptions = () => (
    <>
      {OPTIONS.map((opt, index) => (
        <option
          key={opt.value || index}
          value={opt.value}
          disabled={opt.value === ''}
          hidden={opt.value === '' && value !== ''}
        >
          {opt.label}
        </option>
      ))}
    </>
  );

  return (
    <FormGroup
      as="select"
      name={name}
      value={value}
      handleChange={handleOnChange}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
      errorMessage={errorMessage}
      floatingLabel={formatMessage(messages['registration.preferred_language.label'])}
      options={renderOptions}
    />
  );
};

PreferredLanguageField.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
};

PreferredLanguageField.defaultProps = {
  value: '',
  errorMessage: '',
};

export default PreferredLanguageField;
